
import { useState } from 'react';
import { Assessment, AssessmentResponse } from '@/types/assessment';
import { useRecommendations } from '@/hooks/useRecommendations';
import ResponsesList from './responses/ResponsesList';
import { useRecommendationsDrawer } from '@/hooks/useRecommendationsDrawer';
import { Response, MaturityScoreResult } from '@/hooks/assessment/types/responseTypes';

interface ResponsesTabProps {
  assessment: Assessment;
  responses: AssessmentResponse[];
}

export function ResponsesTab({ assessment, responses }: ResponsesTabProps) {
  // Sort responses by submission timestamp in descending order
  const sortedResponses = [...responses].sort((a, b) => {
    return new Date(b.submittedAt).getTime() - new Date(a.submittedAt).getTime();
  });

  // Convert AssessmentResponse[] to Response[] by mapping the necessary properties
  const convertedResponses: Response[] = sortedResponses.map(response => {
    // Convert maturity scores to the expected format
    const maturityScores: Record<string, MaturityScoreResult> = {};
    
    if (response.maturityScores) {
      Object.entries(response.maturityScores).forEach(([categoryId, scoreData]) => {
        // Explicitly cast scoreData to include the required target property
        const safeScoreData = scoreData as any;
        maturityScores[categoryId] = {
          category: categoryId,
          score: safeScoreData.score,
          level: safeScoreData.level,
          current: safeScoreData.score,
          // Ensure target is present, defaulting to 0
          target: safeScoreData.target || 0
        };
      });
    }
    
    return {
      id: response.id,
      assessment_id: response.assessmentId,
      personal_info: {
        name: response.personalInfo.fullName,
        email: response.personalInfo.email,
        company: response.personalInfo.company
      },
      scores_by_category: response.scoresByCategory || {},
      maturity_scores: maturityScores,
      submitted_at: response.submittedAt,
      answer_details: response.answerDetails || {}
    };
  });

  return (
    <div className="space-y-6">
      {/* Individual Responses List */}
      <ResponsesList 
        assessment={assessment}
        responses={convertedResponses}
      />
    </div>
  );
}
